import Vue from 'vue';
import Router from 'vue-router';

import demoRoutes from './duanwu2023';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/qingyu',
  routes: [
    ...demoRoutes
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/qingyu/index.js